import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import Text from "../Text/Text";
interface TimelineProps {
  events: Array<string>;
  currentEventIndex: number;
  customCurrentTitle?: string;
  header?: string
}

const circleSize = 30;
const lineLength = 86;

const Circle = styled("div")<{ active: boolean }>`
  border-radius: 50%;
  background: #9d7cff;
  width: ${circleSize}px;
  height: ${circleSize}px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.active ? "1" : "0.4")};
`;

const HorizontalLine = styled.div`
  width: ${lineLength}px;
  height: 0;
  border: 1px solid #9d7cff;
  background: #9d7cff;
  margin: 3px;
  display: inline-block;
  opacity: 0.4;
`;

const TimelineContainer = styled("div")`
  position: absolute;
  top: 5%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const TimelineDots = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CurrentEventText = styled(Text)`
  position: absolute;
  padding-top: 80px;
`;

export const Timeline = ({
  events,
  currentEventIndex,
  customCurrentTitle,
  header
}: TimelineProps) => {
  const ref = useRef<null>();
  const currentEventTextRef = useRef<null>();

  useEffect(() => {
    if (ref.current && currentEventTextRef.current) {
      const box = (ref.current as HTMLDivElement).getBoundingClientRect();
      const width = (
        currentEventTextRef.current as HTMLParagraphElement
      ).getBoundingClientRect().width;
      (currentEventTextRef.current as HTMLParagraphElement).style.setProperty(
        "width",
        box.width + 100 + "px"
      );
      (currentEventTextRef.current as HTMLParagraphElement).style.setProperty(
        "left",
        (lineLength + circleSize) * currentEventIndex + "px"
      );
      (currentEventTextRef.current as HTMLParagraphElement).style.setProperty(
        "margin-left",
        -(width / 2) + 20+ "px"
      );
    }
  }, [ref, currentEventTextRef, currentEventIndex]);

  return (
    <TimelineContainer>
      <Text>{header}</Text>
      <TimelineDots ref={ref}>
        {events.map((element, index) => (
          <React.Fragment key={"key" + index}>
            <Circle active={index === currentEventIndex}>
              <p style={{ color: "white" }}>{index + 1}</p>
            </Circle>
            {index !== events.length - 1 && <HorizontalLine />}
          </React.Fragment>
        ))}
      </TimelineDots>
      <CurrentEventText ref={currentEventTextRef}>
        {customCurrentTitle ? customCurrentTitle : events[currentEventIndex]}
      </CurrentEventText>
    </TimelineContainer>
  );
};
